import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SidebarUserCard from '../../components/app/SidebarUserCard';
import { setLastSignedInUser } from '../../utils/controllers/lastSignedInUser';

const UserInfo = ({ data, collapsed = false }) => {
  const navigate = useNavigate();
  const firstName = data?.data?.firstname;
  const lastName = data?.data?.lastname;
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  const email = data?.data?.email;
  const photo = data?.data?.photo;

  // Remembered for the login page's dashboard preview (survives logout).
  useEffect(() => {
    setLastSignedInUser({ name: fullName, email, photo });
  }, [fullName, email, photo]);

  return (
    <SidebarUserCard
      name={fullName}
      email={email}
      photo={photo}
      collapsed={collapsed}
      onClick={() => navigate('/profile')}
    />
  );
};

export default UserInfo;
